export const headerActionMenu = "Oxg4Ce";
export default {headerActionMenu};